"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iconFactory;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var React = _interopRequireWildcard(require("react"));

var _emotionTheming = require("emotion-theming");

var _themeGet = require("@styled-system/theme-get");

var _core = require("@emotion/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function iconFactory(BaseIconComponent, displayName = 'FlameIcon') {
  const EnhancedIcon = (_ref) => {
    let _ref$size = _ref.size,
        size = _ref$size === void 0 ? '1rem' : _ref$size,
        className = _ref.className,
        color = _ref.color,
        baseColor = _ref.baseColor,
        baseColor1 = _ref.baseColor1,
        baseColor2 = _ref.baseColor2,
        detailsColor = _ref.detailsColor,
        detailsColor1 = _ref.detailsColor1,
        detailsColor2 = _ref.detailsColor2,
        theme = _ref.theme,
        restProps = _objectWithoutProperties(_ref, ["size", "className", "color", "baseColor", "baseColor1", "baseColor2", "detailsColor", "detailsColor1", "detailsColor2", "theme"]);

    const themeProp = theme ? {
      theme
    } : {};
    const iconSize = (0, _themeGet.themeGet)("fontSizes.".concat(size), size)(themeProp) || undefined;
    const stylingProps = {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16',
      color: (0, _themeGet.themeGet)("colors.".concat(color), color)(themeProp) || undefined,
      baseColor: (0, _themeGet.themeGet)("colors.".concat(baseColor), baseColor)(themeProp) || undefined,
      baseColor1: (0, _themeGet.themeGet)("colors.".concat(baseColor1), baseColor1)(themeProp) || undefined,
      baseColor2: (0, _themeGet.themeGet)("colors.".concat(baseColor2), baseColor2)(themeProp) || undefined,
      detailsColor: (0, _themeGet.themeGet)("colors.".concat(detailsColor), detailsColor)(themeProp) || undefined,
      detailsColor1: (0, _themeGet.themeGet)("colors.".concat(detailsColor1), detailsColor1)(themeProp) || undefined,
      detailsColor2: (0, _themeGet.themeGet)("colors.".concat(detailsColor2), detailsColor2)(themeProp) || undefined,

      /*
        Keep the cr-icon classname, in case consumers were using it as way
        to set an icons color or fill property.
      */
      className: [className, 'cr-icon'].join(' '),
      style: {
        width: iconSize,
        height: iconSize
      }
    };
    const StyledIcon = ( /*#__PURE__*/0, _styledBase.default)(BaseIconComponent, {
      target: "er8b7wo0",
      label: "StyledIcon"
    })({
      name: "6ezfwo",
      styles: "width:1rem;height:1rem;vertical-align:text-bottom;"
    });
    return (0, _core.jsx)(StyledIcon, _extends({}, stylingProps, restProps));
  };

  const Enhanced = (0, _emotionTheming.withTheme)(EnhancedIcon);
  Enhanced.displayName = displayName; // Temporarely keep this, until we get batch 3 merged in,
  // button still relies on flameName for styling...
  // @ts-ignore

  Enhanced.flameName = 'Icon';
  return Enhanced;
}